import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import {IntlProvider} from "react-intl";
import configureStore from './store/configureStore.js';
import AppContainer from './containers/AppContainer';
import 'bootstrap/dist/css/bootstrap.css';
import './css/vendor/font-awesome/css/font-awesome.css';
require(`./assets/${process.env.PAGE}/css/form.css`)
import messages_ftyc from "./translations/ftyc.json";
import messages_fiduciaria from "./translations/fiduciaria.json";
import messages_fiduciaria_flow_1 from "./translations/fiduciaria_flow_1.json";
import messages_fiduciaria_flow_2 from "./translations/fiduciaria_flow_2.json";
import messages_fiduciaria_flow_3 from "./translations/fiduciaria_flow_3.json";
import messages_fiduciaria_flow_4 from "./translations/fiduciaria_flow_4.json";
import messages_fiduciaria_flow_5 from "./translations/fiduciaria_flow_5.json";
import messages_fiduciaria_flow_6 from "./translations/fiduciaria_flow_6.json";
import messages_fiduciaria_flow_7 from "./translations/fiduciaria_flow_7.json";
import cuyoaval from "./translations/cuyoaval.json";

const messages = {
	'ftyc': messages_ftyc,
	'fiduciaria': messages_fiduciaria,
	'fiduciaria_flow_1': messages_fiduciaria_flow_1,
	'fiduciaria_flow_2': messages_fiduciaria_flow_2,
	'fiduciaria_flow_3': messages_fiduciaria_flow_3,
	'fiduciaria_flow_4': messages_fiduciaria_flow_4,
	'fiduciaria_flow_5': messages_fiduciaria_flow_5,
	'fiduciaria_flow_6': messages_fiduciaria_flow_6,
	'fiduciaria_flow_7': messages_fiduciaria_flow_7,
	'cuyoaval': cuyoaval,
};

const store = configureStore();

ReactDOM.render(
	<IntlProvider locale={'en'} messages={messages[process.env.PAGE]}>
	    <Provider store={store}>
	        <AppContainer/>
	    </Provider>
	</IntlProvider>,

    document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/